'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import CWPopup from '@/context/global/components/g00/g00-d00-g007-cw-popup';

type CWLanguageChangeConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  targetLanguage?: 'th' | 'en';
};

export const CWLanguageChangeConfirm = ({
  isOpen,
  onClose,
  onConfirm,
}: CWLanguageChangeConfirmProps) => {
  const t = useTranslations('LanguageChange');

  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <CWPopup
      isOpen={isOpen}
      onClose={onClose}
      title={t('title')}
      leftButtonText={t('cancel')}
      rightButtonText={t('confirm')}
      onLeftButtonClick={onClose}
      onRightButtonClick={handleConfirm}
      leftButtonProps={{
        variant: 'primary',
        outline: true,
        className:
          'h-[60px] w-[200px] border-2 border-white text-white text-[24px] font-medium hover:border-ais-green hover:text-ais-green hover:bg-white/10',
      }}
      rightButtonProps={{
        variant: 'primary',
        outline: true,
        className:
          'h-[60px] w-[200px] bg-ais-green text-black text-[24px] font-medium hover:border-ais-green hover:text-ais-green hover:bg-white/10',
      }}
      className="max-w-[600px] p-[40px]"
    />
  );
};
